import React from 'react'
import Header from "../Header";
import Footer from "../Footer";
import Adminform from '../Adminform';

function Adminpage() {
    return (
        <div>
            <Header/>
            <Adminform/>
            <Footer/>
        </div>
    )
}

export default Adminpage
